import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_eventbooth-app/artifacts/q2jc85s9_1768277124501.png';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={LOGO_URL} alt="Luxe Lens Events" className="footer-logo" />
            <p className="footer-tagline">
              Creating Moments Beyond the Camera
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/share/1CPqbeGBYo/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com/luxelensevents" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <nav className="footer-nav">
              <Link to="/">Home</Link>
              <Link to="/services">Services</Link>
              <Link to="/gallery">Gallery</Link>
              <Link to="/reviews">Reviews</Link>
              <Link to="/book">Book Now</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <nav className="footer-nav">
              <Link to="/services#360-booth">360 Photo Booth</Link>
              <Link to="/services#mirror-booth">Mirror Booth</Link>
              <Link to="/services#classic-booth">Classic Booth</Link>
              <Link to="/services#packages">Event Packages</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Us</h4>
            <div className="footer-contact">
              <a href="tel:+14784842245">
                <Phone size={16} />
                <span>(478) 484-2245</span>
              </a>
              <a href="mailto:luxelenseventllc@gmail.com">
                <Mail size={16} />
                <span>luxelenseventllc@gmail.com</span>
              </a>
              <div className="footer-address">
                <MapPin size={16} />
                <span>Macon, Georgia</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Luxe Lens Events LLC. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
